import styled, { css } from 'styled-components';
import { shade, transparentize } from 'polished';
import BotaoComConfirmacao from '../../../../../../components/Botoes/BotaoComConfirmacao';
import {
  backgroundColorLigthButton,
  colorLigthButton,
  backgroundColorGrayButton,
  backgroundColorSuccess,
  colorSuccess,
  backgroundColorInfo,
  colorInfo,
  darkFontColor,
  labelFontColor,
  ligthFontColor,
  titleFontColor,
  formBackgroundColor,
} from '../../../../../../config/Colors/Ligth';

export const Container = styled.div`
  background: ${formBackgroundColor};
  border: 1px solid #eee;
  border-radius: 6px;
  box-shadow: 0 1px 3px ${transparentize(0.9, '#000')};
  padding: 24px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

const Status = styled.div`
  height: 38px;
  padding: 0 14px;
  border-radius: 19px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: ${darkFontColor};

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
  }
`;

export const StatusRodando = styled(Status)`
  background-color: ${backgroundColorSuccess};
  color: ${colorSuccess};
  border: 1px solid ${shade(0.1, backgroundColorSuccess)};

  &::before {
    background-color: ${colorSuccess};
  }
`;

export const StatusConsultando = styled(Status)`
  background-color: ${backgroundColorInfo};
  color: ${colorInfo};
  border: 1px solid ${shade(0.1, backgroundColorInfo)};

  &::before {
    background-color: ${colorInfo};
  }
`;

/* Neutro, não vermelho: estar sem sincronização em andamento é repouso, não erro. */
export const StatusParada = styled(Status)`
  background-color: ${backgroundColorGrayButton};
  color: ${darkFontColor};
  border: 1px solid #e4e4e4;

  &::before {
    background-color: ${ligthFontColor};
  }
`;

export const Checkpoint = styled.small`
  font-size: 11px;
  color: ${ligthFontColor};

  strong {
    color: ${darkFontColor};
    font-weight: 600;
  }
`;

export const Secao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid #eee;
  padding-top: 20px;
`;

export const SecaoHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  h2 {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${titleFontColor};
  }
`;

export const Descricao = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: ${ligthFontColor};
  max-width: 760px;
`;

export const Contador = styled.span`
  font-size: 12px;
  color: ${ligthFontColor};
`;

export const LinksSelecao = styled.div`
  display: flex;
  gap: 16px;

  button {
    background: none;
    border: none;
    padding: 0;
    font-size: 12px;
    font-weight: 600;
    color: ${labelFontColor};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

interface ListaEntidadesProps {
  travada: boolean;
}

export const ListaEntidades = styled.div<ListaEntidadesProps>`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 8px;

  ${props =>
    props.travada &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
`;

export const Aviso = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 4px;
  background: ${backgroundColorInfo};
  border: 1px solid ${shade(0.05, backgroundColorInfo)};
  font-size: 12px;
  line-height: 1.5;
  color: ${colorInfo};

  svg {
    font-size: 18px;
    flex-shrink: 0;
  }
`;

interface EntidadeProps {
  selecionada: boolean;
}

export const Entidade = styled.label<EntidadeProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  transition: all 150ms;

  border: 1px solid
    ${props => (props.selecionada ? backgroundColorLigthButton : '#e4e4e4')};
  background: ${props =>
    props.selecionada
      ? transparentize(0.75, backgroundColorLigthButton)
      : formBackgroundColor};
  color: ${props => (props.selecionada ? colorLigthButton : labelFontColor)};
  font-weight: ${props => (props.selecionada ? 600 : 400)};

  &:hover {
    background: ${props =>
      props.selecionada
        ? transparentize(0.65, backgroundColorLigthButton)
        : backgroundColorGrayButton};
    border-color: ${props =>
      props.selecionada ? shade(0.1, backgroundColorLigthButton) : '#c4c4c4'};
  }

  /* Mantém o checkbox acessível ao teclado sem exibi-lo. */
  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:focus-visible ~ span {
    outline: 2px solid ${labelFontColor};
    outline-offset: 2px;
    border-radius: 2px;
  }

  svg {
    font-size: 18px;
    flex-shrink: 0;
    color: ${colorLigthButton};
    opacity: ${props => (props.selecionada ? 1 : 0.15)};
    transition: opacity 150ms;
  }
`;

export const Rodape = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #eee;
  padding-top: 20px;
`;

export const BotaoSincronizar = styled(BotaoComConfirmacao)`
  && {
    background: ${backgroundColorLigthButton};
    color: ${colorLigthButton};
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    padding: 0 20px;
    border-radius: 4px;
    transition: all 200ms;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;

    &:hover {
      background: ${shade(0.15, backgroundColorLigthButton)};
    }

    &:disabled {
      background: ${transparentize(0.5, backgroundColorLigthButton)};
      color: ${transparentize(0.3, colorLigthButton)};
      cursor: not-allowed;
    }

    & > svg {
      display: inline-flex;
      vertical-align: middle;
    }
  }
`;
